<template>
  <div id="rac-com-filtros">
    <v-row class="mx-auto">
      <v-col cols="12">
        <span style="color: rgba(0, 0, 0, 0.54); font-size: 15px">Filtros de execução</span>
      </v-col>
      <v-col cols="12">
        <v-alert dense outlined type="info" color="blue" class="pa-2 mb-0">
          Todos os filtros são opcionais. Sem preenchimento, serão consideradas todas as obras elegíveis na base.
        </v-alert>
      </v-col>
    </v-row>

    <v-row class="mx-auto">
      <v-col cols="12">
        <v-select
          id="rac-com-filtros-tipo-base"
          v-model="_filtros.tipoBase"
          label="Tipo da base"
          item-value="key"
          item-text="value"
          :items="tipoBaseItems"
        />
      </v-col>
    </v-row>

    <v-row class="mx-auto">
      <v-col cols="9">
        <v-textarea
          id="rac-com-filtros-obras"
          v-model="_filtros.obras"
          class="mt-0 pt-0"
          label="Obras"
          placeholder="Insira os códigos das obras, um por linha. Ex.:

CI1944457111
CI1944457348"
          rows="5"
          no-resize
          clearable
          clear-icon="mdi-close-circle"
        />
      </v-col>
      <v-col id="rac-com-filtros-obras-nao-pertence" class="mt-12 pl-0" cols="3">
        <v-checkbox v-model="_filtros.obrasNaoPertencem" class="my-0 py-0" hide-details label="Não pertence" />
      </v-col>
    </v-row>

    <v-row id="rac-com-filtros-data-imobilizacao" class="mx-auto">
      <v-col class="pb-0 pt-1" cols="5">
        <v-menu
          v-model="_filtros.menuPickerImob[0]"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <validation-provider
              v-slot="{ errors }"
              :rules="{
                required_if: _filtros.dataImob.fimFormatted != null && _filtros.dataImob.fimFormatted.length > 0,
                min: 10
              }"
            >
              <v-text-field
                v-model="_filtros.dataImob.inicioFormatted"
                v-mask="'##/##/####'"
                :error-messages="errors"
                class="pt-0"
                label="Data Imobilização"
                prepend-icon="mdi-calendar"
                clearable
                v-bind="attrs"
                v-on="on"
                @blur="_filtros.dataImob.inicio = parseDate(_filtros.dataImob.inicioFormatted)"
              />
            </validation-provider>
          </template>
          <v-date-picker
            v-model="_filtros.dataImob.inicio"
            locale="pt-br"
            @input="
              _filtros.menuPickerImob[0] = false;
              _filtros.dataImob.inicioFormatted = formatDate(_filtros.dataImob.inicio);
            "
          />
        </v-menu>
      </v-col>
      <v-col class="pb-0 pt-5 text-center" style="min-width: 60px !important" cols="2">
        <span style="color: rgba(0, 0, 0, 0.54); font-size: 15px">até</span>
      </v-col>
      <v-col class="pb-0 pt-1" cols="5">
        <v-menu
          v-model="_filtros.menuPickerImob[1]"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <validation-provider
              v-slot="{ errors }"
              :rules="{
                required_if: _filtros.dataImob.inicioFormatted != null && _filtros.dataImob.inicioFormatted.length > 0,
                min: 10
              }"
            >
              <v-text-field
                v-model="_filtros.dataImob.fimFormatted"
                v-mask="'##/##/####'"
                :error-messages="errors"
                class="pt-0"
                label="Data Imobilização"
                prepend-icon="mdi-calendar"
                clearable
                v-bind="attrs"
                v-on="on"
                @blur="_filtros.dataImob.fim = parseDate(_filtros.dataImob.fimFormatted)"
              />
            </validation-provider>
          </template>
          <v-date-picker
            v-model="_filtros.dataImob.fim"
            locale="pt-br"
            @input="
              _filtros.menuPickerImob[1] = false;
              _filtros.dataImob.fimFormatted = formatDate(_filtros.dataImob.fim);
            "
          />
        </v-menu>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import DateFormatterMixins from '@/mixins/dateFormatterMixins.js';

  export default {
    name: 'FiltrosExecucaoRacionalizacaoCom',

    mixins: [DateFormatterMixins],

    props: {
      filtros: {
        type: Object,
        required: true
      }
    },

    emits: ['update:filtros'],

    data: () => ({
      tipoBaseItems: [
        { key: 'AMBAS', value: 'Ambos' },
        { key: 'AIC', value: 'Obra em Curso' },
        { key: 'AIS', value: 'Obra Unitizada' }
      ]
    }),

    computed: {
      _filtros: {
        get() {
          return this.filtros;
        },
        set(value) {
          this.$emit('update:filtros', value);
        }
      }
    }
  };
</script>
